export default __webpack_public_path__ + "maps-examples-dds-circle-layer-1200-8060b7593eab9bc122d8c7a8f52bd85a.png";